if (!customElements.get('whatsapp-float-button')) {
  customElements.define(
    'whatsapp-float-button',
    class WhatsappFloatButton extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.whatsapp-float__button');
        this.revealed = false;

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        this.button.addEventListener('click', () => {
          this.classList.toggle('is-open');
        });

        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) {
            this.classList.remove('is-open');
          }
        });
      }

      onScroll() {
        if (this.revealed) return;
        // Reveal once the visitor has scrolled roughly two screens down
        // (past the hero/gallery, into the description area), then stay
        // visible permanently even if they scroll back up.
        if (window.scrollY > window.innerHeight * 1.4) {
          this.revealed = true;
          this.classList.add('is-visible');
          window.removeEventListener('scroll', this.onScroll);
        }
      }
    }
  );
}
